import { CHANGE_PROFILE_PICTURE_API, GET_PROFILE_DETAILS_API } from '~/constants/APIs'
import axiosClient from './axiosClient'
import { IUserDetails } from '~/models'

export const userProfileApis = {
  getProfileDetails: () =>
    axiosClient.get(GET_PROFILE_DETAILS_API) as unknown as IUserDetails,
  changeProfilePicture: (file: File) => {
    const formData = new FormData()
    formData.append('formFile', file)
    return axiosClient.put(CHANGE_PROFILE_PICTURE_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
